<template>
  <a-modal
    v-model:open="open"
    :width="loginPopoverProps.select.width"
    :height="loginPopoverProps.select.height"
    :centered="true"
    :footer="null"
    :title="loginPopoverProps.select.title"
    :maskClosable="true"
    :wrapClassName="loginPopoverProps.select.className"
  >
    <SelectBase @select="emit('select', $event)" @gotoLogin="emit('gotoLogin')" />
  </a-modal>
</template>
<script lang="ts" setup>
import SelectBase from './base.vue';
import { loginPopoverProps as getLoginPopoverProps } from '~/constants/login';
// 登录地方使用了
const loginPopoverProps = getLoginPopoverProps();
const props = defineProps<{ open: boolean }>();

const emit = defineEmits(['update:open', 'select', 'gotoLogin']);

const open = useVModel(props, 'open', emit);
</script>
